import { Tab, Tabs } from 'react-bootstrap'

const PersonnelTabs = ({ t, activeKey, onSelect }) => (
	<Tabs activeKey={activeKey} onSelect={onSelect} className="mb-3">
		<Tab eventKey="employees" title={t('Employees', 'Työntekijät')} />
		<Tab eventKey="external-workforce" title={t('ExternalParties', 'Ulkopuoliset toimijat')} />
	</Tabs>
)

export default PersonnelTabs
